import Star from './icons/Star'

export default function TotalRating ({ rating, onRatingChange, canRate = false }) {
  const renderStars = () => {
    const stars = []

    for (let i = 0; i < 5; i++) {
      const classNames = i < 4 ? 'me-2 d-flex' : 'd-flex'

      if (i < rating) {
        stars.push(
          <Star
            key={i}
            color="#4093FF"
            className={classNames}
            onClick={() => onRatingChange(canRate ? i + 1 : 0)}
          />
        )
      } else {
        stars.push(
          <Star
            key={i}
            color="#D9D9D9"
            className={classNames}
            onClick={() => onRatingChange(canRate ? i + 1 : 0)}
          />
        )
      }
    }

    return stars
  }

  return (
    <div className="d-flex align-items-center">
      {
        renderStars()
      }
    </div>
  )
}
